<template>
  <div>
    <div class="app-wrap">
      <AppSignUpHeader
        :headerText="headerText"
        :headerBtn="false"
      />
      <ProgressBar>
        <template #text>가입완료</template>
        <template #step4>
          <div class="progress-on"></div>
        </template>
      </ProgressBar>
      <div class="signup-fin-wrap">
        <img src="@/assets/img/img_menu_bi.png" alt="img_menu_bi" class="main-img">
        <div class="title">
          <span>가입</span>이 완료되었습니다.
        </div>
        <!-- <div class="text">
          배달비 무료 !<br>모든오더로 배달비 0원의<br>혜택을 마음껏 누리세요
        </div> -->
      </div>
      <div class="signup-fin-info">
        <div class="info1">시작하시면 자동로그인 됩니다.</div>
        <div class="info2">설정 > 자동로그인 해제 시<br>설정하신 간편비밀번호로 로그인 후 사용해주세요.</div>
      </div>
      <button class="full-login-btn" @click="startBtn">
        시작하기
      </button>
    </div>
  </div>
</template>

<script lang="js">
import AppSignUpHeader from '@/components/Header/AppSignUpHeader.vue'
import ProgressBar from '@/components/SignUp/ProgressBar.vue'
import Store from '@/store'
export default {
  components: {
    AppSignUpHeader,
    ProgressBar
  },
  data () {
    return {
      headerText: '시작하기'
    }
  },
  methods: {
    startBtn () {
      if (this.$store.getters.LoginAuthFlag) {
        this.$router.push({ name: 'ORDER' })
      } else {
        this.appMoveFirstAddress()
      }
    }
  }
}
</script>

<style>

</style>
